import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export type THomeClientReportService = {
  vendedor?: string
  payload: {
    typeDashboard: number // 1 = Agendados 2 = estrategia de venda // 3 = inativo 1 mes // 4 = inativo ha 3 meses // 5 = inativo ha 6 meses
  }
}

export const homeClientReportService = async ({
  vendedor,
  payload,
}: THomeClientReportService): Promise<ResponseAPI> => {
  const response = await api.get(`relperfilcliente/${payload.typeDashboard}`, { headers: vendedor ? { vendedor } : undefined })

  return response.data
}
